import React, { useState } from "react";
import { Mail, Phone, Instagram, MapPin, Clock } from "lucide-react";
import "./Contact.css";

function Contact() {
  const [hoveredCard, setHoveredCard] = useState(null);

  const contactInfo = [
    {
      id: 1,
      icon: <Phone className="contact-icon" />,
      title: "WhatsApp",
      value: "+62 877-8201-5410",
      link: "https://wa.me/+6287782015410",
      color: "#25D366",
    },
    {
      id: 2,
      icon: <Instagram className="contact-icon" />,
      title: "Instagram",
      value: "bms_brothers",
      link: "https://www.instagram.com/bms_brothers/",
      color: "#E4405F",
    },
    {
      id: 3,
      icon: <Mail className="contact-icon" />,
      title: "Email",
      value: "project@bmsbrothers.com",
      link: "mailto:project@bmsbrothers.com",
      color: "#EA4335",
    },
    {
      id: 4,
      icon: <MapPin className="contact-icon" />,
      title: "Location",
      value: "Mall Atrium Pondok Gede",
      link: "https://maps.app.goo.gl/hx91AfmQYa6hZYAn8",
      color: "#4285F4",
    },
    {
      id: 5,
      icon: <Clock className="contact-icon" />,
      title: "Business Hours",
      value: "Mon - Sat: 9AM - 6PM",
      color: "#34A853",
    },
  ];

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1 className="contact-title">Get in Touch</h1>
        <p className="contact-subtitle">
          We'd love to hear from you. Let's create something awesome together!
        </p>
      </div>

      <div className="contact-grid">
        {contactInfo.map((item) => (
          <div
            key={item.id}
            className={`contact-card ${
              hoveredCard === item.id ? "hovered" : ""
            }`}
            onMouseEnter={() => setHoveredCard(item.id)}
            onMouseLeave={() => setHoveredCard(null)}
            style={{
              "--card-color": item.color,
            }}
          >
            <div className="card-content">
              <div
                className="icon-wrapper"
                style={{ backgroundColor: item.color }}
              >
                {item.icon}
              </div>
              <h3>{item.title}</h3>
              {item.link ? (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-value"
                >
                  {item.value}
                </a>
              ) : (
                <p className="contact-value">{item.value}</p>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="contact-footer">
        <h2>Send Us a Message</h2>
        <p>Ready to start your next event project? We're here to help!</p>
        <button
          className="contact-cta"
          onClick={() =>
            (window.location.href = "mailto:project@bmsbrothers.com")
          }
        >
          Let's Talk
        </button>
      </div>
    </div>
  );
}

export default Contact;
